import { useMediaQuery } from '@mui/material';

export const useIsTabletOrMobile = () => {
  return useMediaQuery('(max-width:1224px)');
};
